import { invert } from 'lodash'

export const PLATFORMS = {
  ios: 'ios',
  android: 'android',
  windows: 'windows',
  mdmWindows: 'mdmWindows',
}

export const ODATATYPE_TO_APP_PLATFORM = {
  '#microsoft.graph.iosManagedAppProtection': PLATFORMS.ios,
  '#microsoft.graph.androidManagedAppProtection': PLATFORMS.android,
  '#microsoft.graph.windowsManagedAppProtection': PLATFORMS.windows,
  '#microsoft.graph.mdmWindowsInformationProtectionPolicy': PLATFORMS.mdmWindows,
}

export const APP_PLATFORM_TO_ODATATYPE = invert(ODATATYPE_TO_APP_PLATFORM)
